<template>
  <div>
    <p class="headerstyle">เเก้ไขวีดีโอ</p>
    <div class="w-full fromstyle">
      <form @submit.prevent="editVideo">
        <br />

        <vs-input
          class="w-full"
          id="header"
          placeholder="ชื่อวีดีโอ"
          v-model="videoname"
          required
        />

        <br />
        <div class="flex items-center">
          <button type="button" class="upload-btn" @click="onPickFile" disabled>
            <img
              class="upload-btn-img"
              src="@/assets/images/elements/upload-btn.svg"
            />
          </button>
          <input
            type="file"
            style="display: none"
            ref="fileInput"
            @change="pickFile($event)"
          />
          <p class="flex items-center ml-3 h-full" v-if="this.File">
            {{ this.File.name }}
          </p>
        </div>
        <br />

        <br />
        <div class="flex justify-center">
          <button class="share-btn">
            แก้ไขวีดีโอ
          </button>
        </div>
        <p class="footer-text">
          วีดีโอเมื่อถูกเพิ่มแล้ว จะอยู่ในสถานะ “ยังไม่เผยแพร่” <br />
          โดยสามารถปรับเป็น “เผยแพร่” ได้ในภายหลัง
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../util/backend";
import * as tus from "tus-js-client";
import baseUrl from "../../../util/baseUrl";

export default {
  methods: {
    onPickFile() {
      this.$refs.fileInput.click();
    },

    pickFile(e) {
      this.File = e.target.files[0];
    },

    editVideo() {
      this.$vs.loading();
      let config = {
        method: "put",
        url: `${baseUrl.baseurl()}/updateVideo`,
        data: {
          video_id: this.$route.params.id,
          name: this.videoname.trimLeft()
        }
      };
      axios
        .api(config)
        .then(res => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "แก้ไขวิดีโอ",
            text: "สำเร็จ",
            color: "success",
            icon: "check_box",
            position: "top-right"
          });

          this.$router.push({ path: `/course/${this.data.course_id}` });
        })
        .catch(err => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error message",
            text: `${err.response.data.error ? err.response.data.error : err}`,
            color: "danger",
            icon: "error",
            position: "top-right"
          });
        });
    },

    Syncdata() {
      this.videoname = this.data.data.name;
      this.File = { name: this.data.data.url };
    }
  },
  async mounted() {
    this.Syncdata();
  },
  data() {
    return {
      File: [],
      vidLink: "",
      vidList: [],
      vidPercent: "0.00%",
      player: null,
      videoname: null
    };
  },
  computed: {
    ...mapGetters({
      data: "general/editPage"
    })
  }
};
</script>

<style lang="scss" scoped>
.uploadbanner {
  border: red;
  height: 100px;
}
.fromstyle {
  padding: 0;
}

.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
}

.radiobanner {
  display: flex;
  justify-content: flex-start;
}
.radioitem {
  margin-right: 10px;
}
.fixtimepicker {
  z-index: 99;
}
.bannerimage {
  height: 250px;
  max-width: 100%;
}

.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}
.back-btn {
  background: none !important;
  border: none;
  &:hover {
    transition: 10ms;
    padding-left: 10px;
  }
}
.uploadfield {
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-style: solid;
  border-color: #979aa1;
  border-radius: 10px;
  border-width: 2px;
  padding: 15px;
  background-color: #ffffff;
}
.upload-btn {
  border-radius: 10px;
  border-style: none;
  height: 42.5px;
}
.upload-btn-img {
  height: 42.5px;
}

.video-container {
  position: relative;
  padding-top: 56.25%;
  width: 100%;
}
</style>
